import * as consts from './AgentConsts';

const initialState = {
    agentInfo: {
        id: 0,
        name: '',
        company: '',
        phone: '',
        mobilePhone: '',
        businessPhone: '',
        fax: '',
        email: '',
        website: '',
        orig_website: '',
        logo: '',
        photo: '',
        address: ''
    },
    colisterInfo: {
        id: 0,
        name: '',
        company: '',
        phone: '',
        mobilePhone: '',
        businessPhone: '',
        fax: '',
        email: '',
        website: '',
        orig_website: '',
        logo: '',
        photo: '',
        address: ''
    },
    contactAgentPending: false,
    contactAgentSent: false,
    contactAgentError: ''
};
const agent = (state = initialState, action) => {
    switch (action.type) {
        case consts.SEND_EMAIL_PENDING:
            return {
                ...state,
                contactAgentPending: true
            }
        case consts.SEND_EMAIL_FULFILLED:
            return {
                ...state,
                contactAgentPending: false,
                contactAgentSent: true
            }
        case consts.SEND_EMAIL_REJECTED:
            return {
                ...state,
                contactAgentPending: false,
                contactAgentSent: false,
                contactAgentError: action.payload
            }
        default:
            return state
    }
}

export default agent;
